import { Injectable } from '@angular/core';
import { DatDbConfig } from '@dat/db';

import { DatiqAnalyticsConfig } from './datiq-analytics-config';
import {
    IDatiqChatLiveClientConfig,
    IDatiqLink,
    IDatiqRoute,
} from './datiq-app.interface';
import { DatiqEnvironments } from './datiq-app.models';
import { IDatiqLogConfig } from './datiq-log-otel.interface';
import { DatiqOptimizelyConfig } from './datiq-optimizely.models';
import { IDatiqRulesData } from './datiq-rules.interface';
import { IDatiqUnavItem } from './datiq-unav.interface';

@Injectable()
export class DatiqAppConfig {
    useMock: boolean = false;
    isProd?: boolean = false;
    dbConfig?: DatDbConfig = new DatDbConfig();
    analyticsConfig?: DatiqAnalyticsConfig = new DatiqAnalyticsConfig();
    coreConfig?: DatiqCoreConfig;
    environment?: string = `${DatiqEnvironments.Test}`;
    googleApiKey?: string = 'AIzaSyDB3XrQ9ZVmKy5fR6h63s6TkIfoE1z8aLI';
    headers?: { [key: string]: string | string[] };
    links?: IDatiqRulesData<IDatiqUnavItem>[] = [];
    userLinks?: IDatiqRulesData<IDatiqUnavItem>[] = [];
    currentRoute?: IDatiqRoute;
    noAccessLink?: IDatiqLink;
    optimizelyConfig?: DatiqOptimizelyConfig;
    chatLiveClientConfig?: { [key: string]: IDatiqChatLiveClientConfig };
    log?: IDatiqLogConfig;
}

class DatiqCoreConfig {
    FREIGHT_SUGGESTION_ENDPOINT?: string =
        'https://analytics.api.nprod.dat.com/geo/v2/suggestions';
    GRAPHQL_URL?: string =
        'https://analytics.api.nprod.dat.com/analyticsfacade/graphql';
    GRAPHQL_URL_ONE?: string;
    ANALYTICS_BASE_URL?: string = 'https://analytics.api.nprod.dat.com';
    mockGraphQl?: boolean = false;
    RFP_ROOT_URL?: string = 'https://analytics.api.nprod.dat.com/rfp-service';
    BA_ROOT_URL?: string = 'https://analytics.api.nprod.dat.com/benchmark/v1';
    BA_BROKER_ROOT_URL?: string =
        'https://analytics.api.nprod.dat.com/benchmark-broker/v1';
    BA_USER_SHARED_SETTINGS_ROOT_URL?: string = 'https://analytics.api.nprod.dat.com/shared-user-settings/v1';
    CACHE_BREAKER_QUERY?: string = ''; // This is being used in Trendlines to break the cache
    IQ_BASE_URL?: string = 'https://iq.nprod.dat.com';
}
